export enum EBannerType {
  MortgageBroker,
  SubsidisedMortgage,
  DailyRent,
  CPD1000,
}
